import { Select, TextArea } from 'common/InputForm';
import { CustomModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useState } from 'react'
import { changeSupportStatusApi } from 'services/support';

const UpdateSupportStatus = ({ show, close, data, listing = () => { }, }) => {

    const [error, setError] = useState({});
    const [buttonLoader, setButtonLoader] = useButtonLoader("submit");
    const currentStatus = data?.status;
    const [input, setInput] = useState({
        status: "",
        rejectionReason: '',
        message: '',
    })
    // -----------handle-close----------------
    const modalClose = (e) => {
        close()
        setInput({ status: "", rejectionReason: '', message: '' })
        setError({})
    };
    // -----------modal-onchange----------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        const noLeadSpace = value.replace(/^\s+/, '');
        setInput({ ...input, [name]: noLeadSpace });
    };
    // ------------validation-----------------
    const validation = () => {
        let errorMessage = {};
        let status = true;

        if (!input.status) {
            errorMessage['status'] = 'Please Select status';
            status = false;
        }

        if (input?.status === 'REJECTED' && !input.rejectionReason) {
            errorMessage['rejectionReason'] = 'Please enter Reject Reason';
            status = false;
        }
        if (input?.status === 'RESOLVED' && !input.message) {
            errorMessage['message'] = 'Please enter Message';
            status = false;
        }
        setError(errorMessage);
        return status;
    };
    // ------------update-status-API--------------------
    const changeStatus = async () => {
        if (validation()) {
            try {
                const payLoad = {
                    status: input?.status || '',
                    ...(input?.message && { message: input?.message }),
                    ...(input?.rejectionReason && { rejectionReason: input?.rejectionReason })
                }
                setButtonLoader(true)
                const res = await changeSupportStatusApi(data?._id, payLoad)
                const { code, message } = res?.data;
                if (code === 200) {
                    // toastMessage(message, 'success', 'addPromoCode')
                    listing()
                    modalClose()
                }
            } catch (e) {
                console.log('e', e)
            } finally {
                setButtonLoader(false)
            }
        }
    }
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={modalClose}
        >
            <h3>Change Status</h3>
            <div className="form_field_wrap">
                <div className="form_field">
                    <Select
                        type="text"
                        label="Status"
                        name="status"
                        value={input?.status}
                        onChange={handleChange}
                        error={error.status}
                    >
                        <option value="" disabled>select Status</option>
                        <option value="RESOLVED">Resolve</option>
                        {/* <option value="REJECTED">Reject</option> */}
                        {currentStatus !== 'PROCESSING' && (
                            <option value="PROCESSING">Processing</option>
                        )}

                    </Select>
                </div>
            </div>
            {/* {input?.status === 'REJECTED' &&
                <div className="form_field_wrap">
                    <div className="form_field">
                        <TextArea
                            type="text"
                            label="Reject Reason"
                            name="rejectionReason"
                            placeholder='Please enter your message'
                            value={input?.rejectionReason}
                            onChange={handleChange}
                            error={error.rejectionReason}
                            maxLength={300}
                        />
                    </div>
                </div>} */}

                {(input?.status === 'REJECTED' || input?.status === 'PROCESSING') && (
    <div className="form_field_wrap">
        <div className="form_field">
            <TextArea
                type="text"
                label={
                    input?.status === 'REJECTED'
                        ? 'Reject Reason'
                        : 'Processing Message'
                }
                name="rejectionReason"
                placeholder="Please enter your message"
                value={input?.rejectionReason}
                onChange={handleChange}
                error={error.rejectionReason}
                maxLength={300}
            />
        </div>
    </div>
)}
            {input?.status === 'RESOLVED' &&
                <div className="form_field_wrap">
                    <div className="form_field">
                        <TextArea
                            type="text"
                            label="Message"
                            name="message"
                            placeholder='Please enter your message'
                            value={input?.message}
                            onChange={handleChange}
                            error={error.message}
                            maxLength={300}
                        />
                    </div>
                </div>}

            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={modalClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={changeStatus}
                    className="button"
                >
                    Submit
                </button>
            </div>
        </CustomModal>
    )
}

export default UpdateSupportStatus
